import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ComponentId, ComponentStore, dom, AccordionItem, AccordionItemState, SplitContainerItem, Accordion } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { AppComponent, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { FinanceBrowserAdapter, ItemsBrowserAdapter, AgingBrowserAdapter, GeneralBrowserAdapter } from "../adapters";
import { DefinitionApplication } from "..";

@customElement('rp-definition-sidebar')
export class Sidebar extends AppComponent<DefinitionApplication> {

	static styles = [style];

	@query('og-accordion')
	accordion: Accordion;

	browserComponentStore = new ComponentStore<Browser>((id: ComponentId) => {
		const browser = dom.createElement<Browser>('rp-browser');
		browser.addEventListener('browser.select', this._onSelect);
		browser.addEventListener('browser.state', this._onChangeState);
		switch (id) {
			case 'F':
				browser.adapter = new FinanceBrowserAdapter();
				browser.state = this.state?.financeBrowser as BrowserState;
				break;
			case 'I':
				browser.adapter = new ItemsBrowserAdapter();
				break;
			case 'A':
				browser.adapter = new AgingBrowserAdapter();
				break;
			case 'G':
				browser.adapter = new GeneralBrowserAdapter();
				break;
		}
		return browser;
	});
	
	getState() {
		return {
			name: 'sidebar',
			financeBrowser: this.browserComponentStore.items.get('F')?.getState(),
			accordion: this.accordion?.getItemsState(),
		}
	}

	_onChangeState = () => {
 		this.host.dispatchStateEvent();
	}
	
	refresh = () => this.browserComponentStore.items.forEach((component: Browser) => component?.refresh());
	
	layout() {
		this.accordion?.layout();
	}

	_getAccordionItems = () => {
		const items: SplitContainerItem & AccordionItem[] = [];
		this.app.modules.forEach((module) => {
			items.push({
				id: module.module,
				title: msg(module.name),
				icon: { icon: 'cube', color: module.color }
			});
		});
		items.push({
			id: 'G',
			title: msg('General'),
			icon: { icon: 'folder' }
		});

		const saved = this.state?.accordion as AccordionItemState[] | undefined;
		if (saved) {
			items.forEach(item => {
				const s = saved.find(x => x.id === item.id);
				if (s) {
					item.collapsed = s.collapsed;
					item.size = s.size;
				}
			});
		}
		return items;
	};

	_onSelect = (e: BrowserEvent) => {
		if (!e.node || !e.node.key || e.node.folder) return;
		rp.host.open(e.node.key, { title: e.node.value });
	}

	render = () => html`
		<div class="body" id="definition-sidebar">
			<og-accordion
				.createComponent="${(id: ComponentId) => this.browserComponentStore.get(id)}"
				.items="${this._getAccordionItems()}">
			</og-accordion>
		</div>
	`;

}
